import { DateTime } from "luxon"

export const getScheduledDate = type => {
  if (type === 'tomorrow-0900') {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    const { year, month, day } = DateTime.fromISO(tomorrow.toISOString()).toObject()
    return DateTime.fromFormat(`${year}-${month}-${day} 09:00:00`, 'yyyy-M-d HH:mm:ss').toUTC().toString()
  }

  if (type === 'monday-0900') {
    const monday = new Date()
    monday.setDate(monday.getDate() + (((1 + 7 - monday.getDay()) % 7) || 7))
    const { year, month, day } = DateTime.fromISO(monday.toISOString()).toObject()
    return DateTime.fromFormat(`${year}-${month}-${day} 09:00:00`, 'yyyy-M-d HH:mm:ss').toUTC().toString()
  }
}
